"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MobilePopupBottom = _interopRequireDefault(require("../MobilePopupBottom"));
var MobileSelector = function MobileSelector(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    _props$onSelect = props.onSelect,
    onSelect = _props$onSelect === void 0 ? Function.prototype : _props$onSelect,
    _props$popup = props.popup,
    popup = _props$popup === void 0 ? {} : _props$popup;
  var hasOptions = options === null || options === void 0 ? void 0 : options.length;
  return /*#__PURE__*/_react["default"].createElement(_MobilePopupBottom["default"], popup, /*#__PURE__*/_react["default"].createElement(StyledMobileSelector, {
    className: className
  }, hasOptions ? options.map(function (o) {
    return /*#__PURE__*/_react["default"].createElement(StyledItem, {
      key: o.id,
      onClick: function onClick() {
        return onSelect(o);
      }
    }, /*#__PURE__*/_react["default"].createElement(StyledItemText, null, o.value));
  }) : null));
};
var StyledMobileSelector = _styledComponents["default"].div.withConfig({
  displayName: "MobileSelector__StyledMobileSelector",
  componentId: "sc-1hgn6ax-0"
})(["display:flex;flex-direction:column;width:100%;"]);
var StyledItem = _styledComponents["default"].div.withConfig({
  displayName: "MobileSelector__StyledItem",
  componentId: "sc-1hgn6ax-1"
})(["height:48px;padding:8px;display:flex;align-items:center;background:#fff;border-bottom:solid 1px #e6e9ee;"]);
var StyledItemText = _styledComponents["default"].div.withConfig({
  displayName: "MobileSelector__StyledItemText",
  componentId: "sc-1hgn6ax-2"
})(["font-size:16px;line-height:20px;"]);
var _default = exports["default"] = MobileSelector;